import React from 'react';
import './Footer.scss';
import logo from 'images/logo-footer.png';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row mb-5">
          <div className="col-md-5">
            <img src={logo} alt="Doodly" className="logo" />
            <p>Create professional doodle videos in minutes. No tech or design skills needed.</p>
            <p>&copy; Voomly LLC</p>
          </div>
          <div className="col-md-7">
            <div className="row">
              <div className="col-md-4">
                <h5>Resources</h5>
                <ul className="nav flex-column mb-5">
                  <li className="nav-item">
                    <a href="https://www.facebook.com/groups/doodly/">Doodly Design FB Group</a>
                  </li>
                  <li className="nav-item">
                    <a href="https://www.doodly.com/affiliates/">Affiliate Program</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h5>Support</h5>
                <ul className="nav flex-column mb-5">
                  <li className="nav-item">
                    <a href="http://support.doodly.com/en/support/solutions/35000124367">Knowledgebase</a>
                  </li>
                  <li className="nav-item">
                    <a href="http://support.doodly.com/en/support/home">Customer Support</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <h5>Legal</h5>
                <ul className="nav flex-column mb-5">
                  <li className="nav-item">
                    <a href="https://www.doodly.com/terms/privacy/">Privacy Policy</a>
                  </li>
                  <li className="nav-item">
                    <a href="https://www.doodly.com/terms/tos/">Terms Of Use</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <p>
          This site is not a part of the Facebook website or Facebook INC. Additionally, this site is NOT endorsed by
          Facebook in ANY WAY. Facebook is a trademark of Facebook INC. You understand this to be an expression of
          opinions and not professional advice. You are solely responsible for the use of any content and hold Voomly LLC and all members and affiliates harmless in any event or claim. You can also safely assume that I get paid
          anytime you click on a link on this site. We recommend that you do your own Independent research before
          purchasing anything.
        </p>
        <p>
          Disclaimer: We do NOT believe in get rich quick programs. We believe in hard work, adding value and dedication
          to reach your goals. It's a fact that one that does not take action will see no results whatsoever. The
          results featured on this page are not the norm and are extraordinary results from hard work, commitment and
          dedication by following through and taking action. You will get no results whatsoever if you assume by soaking
          up information products, joining program after program your life will change with riches. This is not for you.
          Your results are based upon your actions. If you want a magic button that will fulfil your life with riches
          then please leave this page and do NOT purchase. Our products are intended to help you share your message with
          the world whilst growing your business. We don't make any guarantees about your own results because we don't
          know you. Results in life are solely based on decisions made. We are here to help and guide you to move
          forward faster by giving you awesome content, direction and strategies to reach your end goal. Please check
          the content thoroughly on this page and that you are committed to taking relentless action and will put in the
          effort before you decide to make a purchase. If not then please leave this page and do not purchase.
        </p>
      </div>
    </footer>
  );
}
